<div class="container">
	<div class="modal-handle">
		<div class="modal-handle__line"></div>
		<img class="modal-handle__cross-icon" src="../../../../assets/icon/cross.svg" (click)="modalCtrl.dismiss()" />
	</div>

	@if (icon) {
		<img style="margin-bottom: 25px" src="{{ icon }}" />
	}
	@if (title) {
		<h1 class="title">{{ title | translate }}</h1>
	}
	@if (info) {
		<h3 class="info">
			{{ info | translate }} <span class="phone-number">{{ phoneNumber }}</span>
		</h3>
	}
	@if (subTitle) {
		<p>{{ subTitle }}</p>
	}

	<div class="btns">
		@if (mainButton) {
			<ion-button (click)="dismiss(true)">
				{{ mainButton | translate }}
			</ion-button>
		}
		@if (closeButton) {
			<ion-button class="close" (click)="dismiss(false)">
				{{ closeButton | translate }}
			</ion-button>
		}
	</div>
</div>
